import React from 'react';
import { View, Text } from 'react-native';
import DLOModal from '../../DLOModal';
import DLORadioButton from '../../DLORadioButton';
import DragHandleIcon from './DragHandleIcon';
import { styles } from './styles';
import { AvailableZone } from './types';

interface EditZoneModalProps {
  visible: boolean;
  availableZones: AvailableZone[];
  onClose: () => void;
  onSave: () => void;
  onZoneToggle: (zoneId: string, enabled: boolean) => void;
}

const EditZoneModal: React.FC<EditZoneModalProps> = ({
  visible,
  availableZones,
  onClose,
  onSave,
  onZoneToggle,
}) => {
  return (
    <DLOModal
      visible={visible}
      onClose={onClose}
      title="Edit Zone"
      primaryButtonText="Save"
      secondaryButtonText="Cancel"
      onPrimaryPress={onSave}
      onSecondaryPress={onClose}
      width={400}
      showCloseIcon={false}
    >
      <View style={styles.modalContent}>
        {availableZones.map((zone, index) => (
          <View key={zone.id} style={styles.zoneItem}>
            <View style={styles.zoneItemLeft}>
              <DragHandleIcon color={zone.enabled ? '#3A3A3A' : '#CCCCCC'} />
              <Text style={[
                styles.zoneItemText,
                { color: zone.enabled ? '#3A3A3A' : '#A0A0A0' }
              ]}>{zone.name}</Text>
            </View>
            <DLORadioButton
              selected={zone.enabled}
              onPress={() => onZoneToggle(zone.id, !zone.enabled)}
              size="medium"
            />
          </View>
        ))}
      </View>
    </DLOModal>
  );
};

export default EditZoneModal;